<template>
  <div class="table-responsive">
    <!-------------------- Tabla de Resultados -------------------->

    <table class="table table-lightborder table-striped table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Tienda</th>
          <th>Proveedor</th>
          <th>Usuario</th>
          <th>Fecha</th>
          <th>Fecha Ultima Edición</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="current in dataTabla.results"
          v-bind:key="current.id"
          @click="rowClick(current)"
        >
          <td>{{ current.numero }}</td>
          <td>{{ current.tienda.nombre }}</td>
          <td>
            {{ current.proveedor.codigo }} | {{ current.proveedor.nombre }}
          </td>
          <td>
            <UsuarioEnTablaComponent :current="current.usuario" />
          </td>
          <td>{{ current.fecha }}</td>
          <td>
            <timeago
              :title="current.fecha_creacion"
              :datetime="current.fecha_creacion"
            ></timeago>
          </td>
          <td class="text-center">
            <div
              data-title="Activo"
              data-toggle="tooltip"
              v-html="current.estado_str"
            ></div>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  computed: {
    ...mapGetters({
      dataTabla: "entradascompras/entradas_compra",
    }),
  },
  mounted() {
    this.$store.dispatch("entradascompras/fetch");
  },
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "inventario-entrada_compra-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "inventario-entrada_compra-editar",
          params: { id: current.id },
        });
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("entradascompras/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext,
      });
    },
  },
};
</script>
